// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxWithButton_wrapper__a4VCc","checkbox":"CheckboxWithButton_checkbox__9IlPW","btn":"CheckboxWithButton_btn__5V7jn"};